<script>
import moment from 'moment';

export default {
  name: "conciliation-stp",
  data: () => ({
    operations: [],
    tipoOrdenOpciones: [
      {
        text: 'Recibidas',
        value: 'R'
      },
      {
        text: 'Emitidas',
        value: 'E'
      },
    ],
    fechaOperacion: '',
    tipoOrdenFiltro: {
      text: 'Recibidas',
      value: 'R'
    },
    operationStatusDict: {
      'C': { text: 'Capturada', color: 'success' },
      'PL': { text: 'Pendiente Liberar', color: 'warning' },
      'L': { text: 'Liberada', color: 'success' },
      'PA': { text: 'Pendiente Autorizar', color: 'warning' },
      'A': { text: 'Autorizada', color: 'success' },
      'E': { text: 'Enviada', color: 'success' },
      'XC': { text: 'Por Cancelar', color: 'danger' },
      'CN': { text: 'Cancelada', color: 'danger' },
      'D': { text: 'Devuelto', color: 'danger' },
      'XC': { text: 'Por devolver', color: 'danger' },
      'CL': { text: 'Cancelada local', color: 'danger' },
      'CR': { text: 'Cancelada rechazada', color: 'danger' },
      'RL': { text: 'Rechazada local', color: 'danger' },
      'EA': { text: 'Enviada adapter', color: 'success' },
      'CA': { text: 'Cancelada adapter', color: 'danger' },
      'RA': { text: 'Rechazada adapter', color: 'danger' },
      'RB': { text: 'Rechazada Banxico', color: 'danger' },
      'LQ': { text: 'Liquidado', color: 'success' },
      'CCE': { text: 'Confirmación enviada', color: 'dark' },
      'CXO': { text: 'Por enviar confirma', color: 'dark' },
      'CCO': { text: 'Confirmada', color: 'success' },
      'CCR': { text: 'Confirmación rechazada', color: 'danger' },
      'TC': { text: 'T. capturado', color: 'dark' },
      'TL': { text: 'T. liberado', color: 'dark' },
      'TA': { text: 'T. autorizado', color: 'dark' },
      'TLQ': { text: 'T. liquidado', color: 'success' },
      'TCL': { text: 'T. cancelado', color: 'danger' },
      'EC': { text: 'Enviada confirmada', color: 'dark' },
      'TD': { text: 'Traspaso devuelto', color: 'danger' }
    },
    page: 0
  }),
  async mounted() {
    // fecha operacion igual al dia de hoy
    this.fechaOperacion = moment().format('YYYY-MM-DD')
  },
  methods: {
    async fetchOperations() {
      this.$vs.loading();
      try {
        const { data } = await axios.post('/api/business/treasury/dispersion/conciliation-stp', {
          fechaOperacion: this.fechaOperacion,
          page: this.page,
          tipoOrden: this.tipoOrdenFiltro
        })
        this.operations = data
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al obtener las operaciones',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    async applyOperation(item) {
      this.$vs.loading();

      try {
        await axios.post('/api/business/treasury/dispersion/apply-operation', item)
        this.$vs.loading.close();
        this.$vs.notify({
          title: 'Éxito',
          text: 'Operación aplicada correctamente',
          color: 'success',
          position: 'top-right'
        })
        await this.fetchOperations()
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al aplicar la operación',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    isRefundIncome(item) {
      return item.nombreBeneficiario === null;
    },
    isRgFundIncome(item) {
      return item.cuentaBeneficiario === '646180218900000001';
    },
    isIncome(item) {
      return !this.isRgFundIncome(item) && !this.isRefundIncome(item);
    },
    isConfirmed(item) {
      return item.estado === 'TLQ' || item.estado === 'CCO';
    },
    isDispersable(item) {
      return !!(item.pptrx === null && this.isConfirmed(item) && this.isIncome(item));
    }
  }
}
</script>

<template>
  <div class="mt-10">
    <div class="flex items-end gap-2 ml-5 mb-2">
      <vs-input v-model="fechaOperacion" label="Fecha de operación" type="date"></vs-input>
      <vs-select v-model="tipoOrdenFiltro" label="Tipo de orden">
        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in tipoOrdenOpciones" />
      </vs-select>
      <vs-button @click="fetchOperations">Buscar</vs-button>
    </div>
    <small class="ml-5 mb-5 font-bold">
      Notas: El servicio por default tiene 100 peticiones por hora. Limites de consultas: 100 por hora.
    </small>

    <vx-card title="Conciliación STP">
      <small>Viendo {{ operations.length }} operaciones</small>
      <vs-table :data="operations" search>
        <template slot="thead">
          <vs-th>IdEF</vs-th>
          <vs-th>Estado</vs-th>
          <vs-th>Clave Rastreo</vs-th>
          <vs-th>Referencia num</vs-th>
          <vs-th>Ordentante</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>Beneficiario</vs-th>
          <vs-th>PPTRX</vs-th>
          <vs-th>Acciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data" :class="{
            'text-danger': (isIncome(item) && item.pptrx === null && isConfirmed(item))
          }">
            <vs-td>{{ item.idEF }}</vs-td>
            <vs-td>
              <div :class="`bg-${operationStatusDict[item.estado].color}`"
                class="px-2 text-center py-1 text-white rounded-full text-xs">
                {{ operationStatusDict[item.estado].text }}
              </div>
            </vs-td>
            <vs-td>{{ item.claveRastreo }}</vs-td>
            <vs-td>{{ item.referenciaNumerica }}</vs-td>
            <vs-td>
              <div class="flex flex-col">
                <span class="font-bold">{{ item.nombreOrdenante }}</span>
                <span>{{ item.cuentaOrdenante }}</span>
                <span>{{ item.rfcCurpOrdenante }}</span>
              </div>
            </vs-td>
            <vs-td>{{ item.monto | currency }}</vs-td>
            <vs-td>
              <div class="flex flex-col">
                <span class="font-bold">{{ item.nombreBeneficiario }}</span>
                <span>{{ item.cuentaBeneficiario }}</span>
                <span>{{ item.rfcCurpBeneficiario }}</span>
              </div>
            </vs-td>
            <vs-td>
              <div class="flex flex-col" v-if="item.pptrx !== null">
                <span>{{ item.pptrx.trx_id }}</span>
                <span>{{ item.pptrx.status }}</span>
              </div>
              <div v-else>
                NA
              </div>
            </vs-td>
            <vs-td>
              <feather-icon v-if="item.pptrx === null" icon="PlayCircleIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6"
                @click.stop="applyOperation(item)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <div class="h-24"></div>
  </div>
</template>

<style scoped></style>